export default "__VITE_ASSET__Bw7osL2J__"